import React from "react";
import styles from "../specialities.module.css";
import SpecialitiesBanner from "../../../components/Banners/Speacialities-Banner/speacialities-banner";
import ImageWithText from "../../../components/ImageWithText/ImageWithText";
import SpecialityFeatures from "../../../components/SpecialityFeatures/specialityFeatures";
import TextOnly from "../../../components/TextOnly/textOnly";
import MetaTags from "../../../components/MetaTags";

const InterdeviceCommunicationMgt = () => {
  const bannerContent = {
    heading: "Interdevice Communication Management",
    subText: (
      <>
Managing your delivery operations means that you need a quick and reliable solution for communication. Smooth communication between devices is essential for efficiency and reliability. Ninjas Code’s Interdevice Communication Management ensures your systems work in harmony, enabling real-time updates and coordination across your platform. </>
    ),
  };

  const specialityAbout = [
    {
      aboutImage: {
        url: "assets//Speciality-Images/Seamless-Device-Connectivity.webp",
        alt: "Seamless Device Connectivity",
      },
      aboutTitle: { title: `Seamless Device Connectivity`, highlightedTitle: "" },
      aboutDescription: (
        <>
Ensure all devices—driver apps, customer interfaces, and admin panels—stay interconnected for uninterrupted operations. </>
      ),
      flexReverse: "false",
    },
    {
      aboutImage: {
        url: "assets/Speciality-Images/Real-Time-Data-Exchange.webp",
        alt: "Real-Time Data Exchange",
      },
      aboutTitle: { title: `Real-Time Data Exchange`, highlightedTitle: "" },
      aboutDescription: (
        <>
Facilitate instant communication between devices, ensuring accurate order updates, delivery status, and notifications.</>
      ),
      flexReverse: "true",
    },
    {
      aboutImage: {
        url: "assets/Speciality-Images/Reduced-Downtime.webp",
        alt: "Reduced Downtime",
      },
      aboutTitle: { title: `Reduced Downtime`, highlightedTitle: "" },
      aboutDescription: (
        <>
Minimize disruptions with reliable communication protocols that keep all parts of your system in sync, even during high traffic.</>
      ),
      flexReverse: "false",
    },
    {
      aboutImage: {
        url: "assets/Speciality-Images/Cross-Platform-Compatibility.webp",
        alt: "Cross-Platform Compatibility",
      },
      aboutTitle: { title: `Cross-Platform Compatibility`, highlightedTitle: "" },
      aboutDescription: (
        <>
Our solution works effortlessly across Android, iOS, and web-based platforms, ensuring all users stay connected.</>
      ),
      flexReverse: "true",
    },
    {
      aboutImage: {
        url: "assets/Speciality-Images/Scalable-Architecture.webp",
        alt: "Scalable Architecture",
      },
      aboutTitle: { title: `Scalable Architecture`, highlightedTitle: "" },
      aboutDescription: (
        <>
As your business grows, our system supports more devices and users without compromising speed or reliability.</>
      ),
      flexReverse: "false",
    },
    {
      aboutImage: {
        url: "assets/Speciality-Images/End-to-End-Encryption.webp",
        alt: "End-to-End Encryption",
      },
      aboutTitle: { title: `End-to-End Encryption`, highlightedTitle: "" },
      aboutDescription: (
        <>
Protect sensitive data transmitted between devices with robust security measures, ensuring complete privacy and trust.</>
      ),
      flexReverse: "true",
    },
  ];

  const featurePoints = [
    <>Push notifications and instant updates</>,
    <>API-driven integrations for device synchronization</>,
    <>Secure, encrypted communication protocols</>,
    <>Scalability to support large-scale operations</>,
    <>Compatibility with IoT and third-party systems</>
  ];

  const finalThoughts = [
    {heading: `Keep Your Operations Connected`},
    {subText: `Ninjas Code’s Interdevice Communication Management enables smooth, real-time interactions across your platform, ensuring your business runs like clockwork. Contact us today to learn how we can keep your systems seamlessly connected!
`},
  ]

  return (
    <div>
       <MetaTags
     title="Seamless Interdevice Communication for Smooth Operations"
     description="Keep your operations running smoothly with Ninjas Code Secure Interdevice communication. Get features like scalable architecture, encrypted protocols, and more."
     />
      <SpecialitiesBanner content={bannerContent} />

      <div className={styles.specialitiesAbout}>
        <div className={styles.container}>
          <h2>Benefits of Our Inter Device Communication Solutions</h2>
          <ImageWithText aboutContent={specialityAbout} />
        </div>
      </div>

      <SpecialityFeatures features={featurePoints} />

      <TextOnly 
      content={finalThoughts}
      width
      />
    </div>
  );
};

export default InterdeviceCommunicationMgt;
